import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
// import { Label } from '@playcastdotio/Shadcn';
import clsx from 'clsx';
import { DisplayState } from '@playcastdotio/CoreTypes';
import { isElectron } from '../../api';

type InputProps = {
  displays: DisplayState['displays'];
  onDisplayClick: (index: number) => void;
  selectedId: number;
  showTitle?: boolean;
};

export const DisplayCanvas = ({ displays, onDisplayClick, selectedId, showTitle = true }: InputProps) => {
  // Calculate the overall bounding box for all displays
  const calculateBoundingBox = () => {
    const minX = Math.min(...displays.map((d) => d.properties.bounds.x));
    const minY = Math.min(...displays.map((d) => d.properties.bounds.y));
    const maxX = Math.max(...displays.map((d) => d.properties.bounds.x + d.properties.bounds.width));
    const maxY = Math.max(...displays.map((d) => d.properties.bounds.y + d.properties.bounds.height));

    return {
      minX,
      minY,
      width: maxX - minX,
      height: maxY - minY,
    };
  };

  const boundingBox = calculateBoundingBox();

  return (
    <div className={clsx(isElectron ? 'w-2/5 p-2' : 'w-2/6 p-4', 'relative h-auto')}>
      {/* {showTitle && <Label className='hidden lg:flex font-[Syne] text-primary text-lg mb-4 justify-center'>Choose a Display</Label>} */}
      <div className='relative w-full' style={{ paddingBottom: `${(boundingBox.height / boundingBox.width) * 100}%` }}>
        {displays.map((display, index: number) => {
          const { x, y, width, height } = display.properties.bounds;

          // Normalize x, y, width, and height to be within 0-100%
          const normalizedX = (x - boundingBox.minX) / boundingBox.width;
          const normalizedY = (y - boundingBox.minY) / boundingBox.height;
          const normalizedWidth = width / boundingBox.width;
          const normalizedHeight = height / boundingBox.height;

          const boxStyle: React.CSSProperties = {
            position: 'absolute',
            left: `${normalizedX * 100}%`,
            top: `${normalizedY * 100}%`,
            width: `${normalizedWidth * 100}%`,
            height: `${normalizedHeight * 100}%`,
          };

          return (
            <div key={display.properties.displayName} className='cursor-pointer' style={boxStyle} onClick={() => onDisplayClick(index)}>
              <div
                className={clsx(
                  selectedId === display.displayId ? 'bg-midnight' : 'bg-gray-900',
                  'text-primary hover:bg-midnight-brighter h-full w-full border',
                )}
              />
              {display.properties.isPrimary && (
                <FontAwesomeIcon
                  icon={faStar}
                  className='pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-white'
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
